var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('icon-bubble');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
export var IconBubbleDefaultProps = {
  size: 32,
  iconSize: 18,
  iconColor: 'mid',
  color: 'subtle',
  hoverColor: 'mid'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ", "\n\n  "], ["\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ", "\n\n  "])), function (_a) {
    var size = _a.size,
      _color = _a._color,
      _hoverColor = _a._hoverColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n      border: 1px solid ", ";\n      height: ", "px;\n\n      &:hover {\n        border-color: ", ";\n      }\n    "], ["\n      width: ", "px;\n      border: 1px solid ", ";\n      height: ", "px;\n\n      &:hover {\n        border-color: ", ";\n      }\n    "])), size, theme.COLOR(_color), size, theme.COLOR(_hoverColor));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var IconBubble = function (props) {
  var className = props.className,
    title = props.title,
    size = props.size,
    icon = props.icon,
    iconSize = props.iconSize,
    iconColor = props.iconColor,
    children = props.children,
    color = props.color,
    hoverColor = props.hoverColor;
  return React.createElement(My.Container, {
    _hoverColor: hoverColor,
    _color: color,
    size: size,
    title: title,
    className: cls.name(className)
  }, React.createElement(My.Icon, {
    size: iconSize,
    color: iconColor
  }, icon || children));
};
IconBubble.defaultProps = IconBubbleDefaultProps;
IconBubble.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;